<template>
  <section :class="$options.name" class="tw:flex flex-column tw:gap-6">
    <div>
      <EdroneSelect
        :label="trans._inbox.customer.tags.addTag"
        :options="tags"
        :placeholder="trans._inbox.customer.tags.search"
        :selected-options="[]"
        allow-empty
        searchable
        taggable
        unique-id="4bad23c2-ad8d-4786-aa14-79534c488a5b"
        @add="send({ type: 'CREATE_TAG', tag: $event as unknown as string })"
        @select="handleSelectTag($event.value)"
      >
        <template #tooltip>
          <EdroneTooltip
            :helper="trans._inbox.customer.tags.helper"
            position="top"
            trigger-event="mouseenter click"
            unique-id="20906d3e-ed0e-4756-8194-16756701f035"
          />
        </template>
      </EdroneSelect>
    </div>
    <div>
      <p class="tw:body-1 tw:mb-1">{{ trans._inbox.customer.tags.currentTags }}</p>
      <div class="tw:flex tw:gap-1 flex-wrap">
        <template v-for="tag in customerTags" :key="tag.tagId">
          <EdroneTag
            :text="tag.tagName"
            active
            unique-id="4583b576-e433-4ec3-9c25-c1da8cf3e19b"
            @click="send({ type: 'REMOVE_TAG', tag: tag.tagId })"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useCustomerPreviewActor } from "vue-app/pages/machines/machineCustomerPreview";
import EdroneTooltip from "edrone-components/EdroneTooltip.vue";
import EdroneTag from "edrone-components/EdroneTag.vue";
import EdroneSelect from "edrone-components/EdroneSelect.vue";

export default defineComponent({
  name: "CustomerPreviewTags",
  components: {
    EdroneTooltip,
    EdroneTag,
    EdroneSelect,
  },
  setup() {
    const { state, send } = useCustomerPreviewActor();

    const tags = computed(() => {
      return state.value.context?.tags?.map((tag) => ({ name: tag.tagName, value: tag.tagId })) ?? [];
    });

    const customerTags = computed(() => {
      return (
        state.value.context?.form?.tags
          .filter((customerTag): customerTag is number => customerTag != null)
          .map((customerTag) => {
            const foundTag = tags.value.find((tag) => String(tag.value) === String(customerTag));
            return {
              tagName: foundTag?.name ?? `Tag #${customerTag}`,
              tagId: customerTag,
            };
          }) ?? []
      );
    });

    const handleSelectTag = (tag: string) => {
      const tagId = Number(tag);
      if (customerTags.value.find((customerTag) => customerTag.tagId === tagId)) {
        window.showToast(window._trans._inbox.customer.notifications.tagExistsInfo, "info");
        return;
      }
      send({ type: "ADD_TAG", tag: tagId });
    };

    return {
      send,
      state,
      customerTags,
      tags,
      handleSelectTag,
    };
  },
});
</script>

<style lang="scss" scoped></style>
